import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    invoiceId: String,
    amountDue: String
  }

  connect() {
    if (this.element.dataset.trackingEvent === 'invoice_view' && typeof gtag === 'function') {
      gtag('event', 'invoice_view', {
        invoice_id: this.invoiceIdValue,
        amount_due: this.amountDueValue
      })
    }
  }

  beginPayment(event) {
    if (typeof gtag === 'function') {
      gtag('event', 'begin_payment', {
        invoice_id: this.invoiceIdValue
      })
    }
  }

  paymentSubmit(event) {
    if (typeof gtag === 'function') {
      gtag('event', 'payment_submit', {
        invoice_id: this.invoiceIdValue
      })
    }
  }

  paymentSuccess(event) {
    if (typeof gtag === 'function') {
      gtag('event', 'payment_success', {
        invoice_id: this.invoiceIdValue
      })
    }
  }

  paymentFailure(event) {
    if (typeof gtag === 'function') {
      gtag('event', 'payment_failure', {
        invoice_id: this.invoiceIdValue
      })
    }
  }
}